{
  "error": "Ошибка",
  "help": "Справка",
  "info": "Информация",
  "success": "Успешно",
  "warning": "Предупреждение"
}
